const toTitle = string =>
  string &&
  string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

const numberToText = (number, limit = 999) =>
  number > limit ? `+${limit}` : number;

export default { toTitle, numberToText };
